import {registerSavedWaypoint} from '@gaia/utils/gaia/saveWaypoint';
import keyBy from 'lodash/keyBy';
import pickBy from 'lodash/pickBy';

export default function (
    action: BulkArchiveAction,
    setWaypoints: React.Dispatch<React.SetStateAction<{[localId: string]: Waypoint}>>
) {
    if (!action.ids.length) return [];
    setWaypoints((latestWaypoints) => {
        let archivedWaypoints: Waypoint[] = action.ids.map((id) => {
            if (latestWaypoints[id]) {
                return {
                    ...latestWaypoints[id],
                    properties: {
                        ...latestWaypoints[id].properties,
                        archived: action.archived,
                    },
                };
            } else {
                // Create an empty waypoint to make sure we don't show waypoints
                // that have been deleted without being taken local
                return {
                    type: 'Feature',
                    geometry: {type: 'Point', coordinates: []},
                    properties: {
                        id,
                        archived: action.archived,
                        bulkArchived: true,
                        isLocallyCreated: true,
                        localId: id,
                        title: '',
                        type: 'waypoint',
                    },
                };
            }
        });

        if (action.archived === false) {
            archivedWaypoints = archivedWaypoints.filter(
                (waypoint) => !waypoint.properties.bulkArchived
            );
        }

        // calling registerSavedWaypoint directly is an escape hatch to prevent the
        // save effect from picking up this change
        archivedWaypoints.forEach((waypoint) => registerSavedWaypoint(waypoint));

        // If we are unarchiving, remove the partial local instance
        const existingWaypoints =
            action.archived === false
                ? pickBy(latestWaypoints, (waypoint) => !waypoint.properties.bulkArchived)
                : latestWaypoints;

        return {
            ...existingWaypoints,
            ...keyBy(archivedWaypoints, (waypoint) => waypoint.properties.localId),
        };
    });
    return action.ids;
}
